import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VCalendar from 'v-calendar'

import 'v-calendar/dist/style.css'
import { VueTelInputPlugin } from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";


const app = createApp(App)

// ✅ Define global variables
// app.config.globalProperties.$apiURL = 'http://127.0.0.1:5001'
app.config.globalProperties.$apiURL = 'https://amdtransportation-be-main-build-159134604691.us-central1.run.app'
// app.config.globalProperties.$apiURL = 'https://multitenant-be-demo-main-build-159134604691.europe-west1.run.app'


app.config.globalProperties.$brand = 'AMD Transportation'

// ✅ Use your plugins
app
  .use(store)
  .use(router)
  .use(VCalendar, {})
  .use(VueTelInputPlugin)
  .use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 5,
    newestOnTop: true,
    position: 'top-right',
    timeout: 3000
  })

// ✅ Mount the app last
app.mount('#app')
